export default __webpack_public_path__ + "static/media/Snow_Japan_Color_Logo.4b1b796e.svg";